import React, { CSSProperties } from 'react';
import { ViewProps } from 'react-native';

import './sticky-cell-renderer-component.css';

type StickyCellRendererComponent = ViewProps & { shouldBeSticky: boolean };

/**
 * FlatList cell renderer component that conditionally applies a sticky css class based on the `shouldBeSticky` prop.
 * Used to render items in a FlatList with sticky behavior.
 *
 * Used to obtain sticky behavior in web using `position: sticky`.
 */
export const StickyCellRendererComponent = ({ children, shouldBeSticky, style }: StickyCellRendererComponent) => {
    return (
        <div style={style as CSSProperties} className={shouldBeSticky ? 'sticky-item' : ''}>
            {children}
        </div>
    );
};
